<template>
    <div
        class="footer-powered-by-sellsy"
        :class="{ 'footer-powered-by-sellsy--relative-on-mobile': !fixedOnMobile }"
    >
        <h4 class="footer-powered-by-sellsy__text typographies-heading-h4">
            {{ translations.poweredBy }}
        </h4>
        <a
            href="https://go.sellsy.com/"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-powered-by-sellsy__logo-link"
        >
            <CompassLogo type="logo" :width="84" />
        </a>
    </div>
</template>

<script>
export default {
    props: {
        fixedOnMobile: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            translations: {
                poweredBy: this.$t.__('common.labels.powered_by'),
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.footer-powered-by-sellsy {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-0);
    z-index: 1000;
    background-color: var(--colors-common-background-default);

    &__text {
        margin: 0;
        color: var(--colors-common-text-brand-secondary-blue);
    }

    &__logo-link {
        cursor: pointer;
        text-decoration: none;
    }

    &--relative-on-mobile {
        @media (max-width: 1023px) {
            position: relative;
        }
    }
}
</style>
